import React from 'react';

export const Container: React.FC<{ className?: string }> = ({
  className,
  children,
}) => {
  if (!children) {
    return null;
  }
  return <div className={`container ${className || ''}`}>{children}</div>;
};
